import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { log } from "firebase/firestore/pipelines";
import { AppConfig } from "../models/app-config.interface";


@Injectable({providedIn:'root'})
export class AppConfigService{
    // private config!:AppConfig;
    private configSignal = signal<AppConfig | null>(null);
    config = this.configSignal.asReadonly();



    constructor(private http:HttpClient){

    }

    load(): Promise<void> {
        // console.log("load() called");
        return firstValueFrom(
          this.http.get<AppConfig>('assets/config.json')
        ).then(config => {
          console.log("Config fetched");
          this.configSignal.set(config);

        //   this.config = config;
        });
      }
    

    // getConfig():AppConfig{
    //     console.log("get config");
        
    //     return this.config;
    // }
}